import React from "react";

export default function DateField(props) {
  const {
    field: { type, name, label, required },
    i,
    value,
    handleOnChange
  } = props;
  return (
    <div className={`item-${i} form-group`}>
      <label>
        {label}:
        {required ? <span className="required"> *</span> : null}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={handleOnChange}
        className="form-control"
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/User/UserDetailsForm/renderFields/DateField.js